// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"686cdffc","676":"a9e25867","873":"90dabace","889":"e004b5f3"}[chunkId] + ".chunk.js";
};